import React from "react";
import { Card, CardBody, Heading, Text } from "@pancakeswap-libs/uikit";
import styled from "styled-components";
import useI18n from "hooks/useI18n";
import CardValue from "./CardValue";
import { useVempDetails } from "../../../state/hooks";

const StyledCakeStats = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const CakeStats = () => {
  const TranslateString = useI18n();
  const vempDetails: any = useVempDetails();

  return (
    <StyledCakeStats>
      <CardBody>
        <Heading
          style={{
            fontSize: "24px",
            fontWeight: 600,
            width: "140px",
            margin: "auto",
            marginBottom: "24px",
          }}
          size="xl"
        >
          {TranslateString(534, "Egg Stats")}
        </Heading>
        <Row style={{ gap: "10px" }}>
          <Text fontSize="20px">Circulating supply</Text>
          <CardValue
            value={vempDetails?.circulatingSupplyDisplay}
            decimals={0}
          />
        </Row>
        <Row style={{ gap: "10px" }}>
          <Text fontSize="20px">Market Cap </Text>
          <CardValue value={vempDetails?.marketCap} decimals={0} prefix="$" />
        </Row>
        <Row style={{ gap: "10px" }}>
          <Text fontSize="20px">VEMP Price </Text>
          <CardValue value={vempDetails?.tokenPriceDisplay} decimals={0} />
        </Row>
      </CardBody>
    </StyledCakeStats>
  );
};

export default CakeStats;
